import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const PREMIUM_PLANS = new Set(["premium", "business"]);

/**
 * Guards a route behind Premium- or Business-tier membership.
 * Unauthenticated → /login. Authenticated without required plan → /membership.
 */
export default function RequireMembership({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="pt-24 pb-20 min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-white/30 font-body">Loading...</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  const m = user.membership;
  const qualified = user.role === "admin" || (m?.active && PREMIUM_PLANS.has(m?.plan));
  if (!qualified) {
    return <Navigate to="/membership" replace />;
  }
  return children;
}

export { PREMIUM_PLANS };
